var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuggestedSyndicates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.506 16.915C8.611 16.915 9.506 17.81 9.506 18.915C9.506 20.02 8.611 20.915 7.506 20.915C6.401 20.915 5.506 20.02 5.506 18.915C5.506 17.81 6.401 16.915 7.506 16.915",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.494 16.915C17.599 16.915 18.494 17.81 18.494 18.915C18.494 20.02 17.599 20.915 16.494 20.915C15.389 20.915 14.494 20.02 14.494 18.915C14.494 17.81 15.389 16.915 16.494 16.915",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.729 8.36792C5.834 8.36792 6.729 9.26292 6.729 10.3679C6.729 11.4729 5.834 12.3679 4.729 12.3679C3.624 12.3679 2.729 11.4729 2.729 10.3679C2.729 9.26292 3.624 8.36792 4.729 8.36792",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.08496C13.105 3.08496 14 3.97996 14 5.08496C14 6.18996 13.105 7.08496 12 7.08496C10.895 7.08496 10 6.18996 10 5.08496C10 3.97996 10.895 3.08496 12 3.08496",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.271 8.36792C20.376 8.36792 21.271 9.26292 21.271 10.3679C21.271 11.4729 20.376 12.3679 19.271 12.3679C18.166 12.3679 17.271 11.4729 17.271 10.3679C17.271 9.26292 18.166 8.36792 19.271 8.36792",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.4438C13.105 10.4438 14 11.3388 14 12.4438C14 13.5488 13.105 14.4438 12 14.4438C10.895 14.4438 10 13.5488 10 12.4438C10 11.3388 10.895 10.4438 12 10.4438",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestedSyndicates);
export default __webpack_public_path__ + "static/media/suggested-syndicates.f99c0c20ea1efc2b952c8df29d875c3a.svg";
export { ForwardRef as ReactComponent };